<wr-new-data-table headerText="TGA Baupläne"
                   [infoBanner]="catalogBanner()"
                   localStorageIdentifier="equipment-overview"
                   [loadItemsFunction]="loadEquipments"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToTgaType($event)"
                   (newClick)="add()"
                   [form]="form"
                   [isAdmin]="canCreate()"
                   [deprecatedRows]="true">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input id="textFilter" type="text" nbInput formControlName="text" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="tenant">Firma</label>
          <wr-tenant-select id="tenant"
                            formControlName="tenantId"
                            [tenantType]="TenantTypeEnum.Internal"
                            [showEmptyOption]="true"
          ></wr-tenant-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="deprecated">TGA Status</label>
          <wr-deprecated-select id="deprecated" formControlName="deprecated"></wr-deprecated-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="facilityElement">Technische Einrichtung</label>
          <wr-facility-element-select id="facilityElement" formControlName="facilityElement" [showEmptyOption]="true"></wr-facility-element-select>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-equipment
    key="name"
    display="Name">
    <nb-user [name]="equipment.name"
             [picture]="getIcon(equipment)"
             size="small"></nb-user>
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="color"
    display="Farbe">
    <div class="color-swatch" [style.background]="building.color"></div>
  </ng-template>
  <ng-template
    dataColumn
    let-equipment
    key="tenantName"
    [sortable]="false"
    exportKey="tenant.name"
    display="Firma">
    <wr-tenant-badge [tenant]="equipment.tenant"></wr-tenant-badge>
  </ng-template>
</wr-new-data-table>
